import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  inputFields: {
    paddingTop: 10,
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(4),
    margin: 0,
  },
}));

export default useStyles;
